import { useEffect } from 'react';
import { useStoreApi } from 'reactflow';
import { createViewportZoomSync } from '@hooks/canvas/viewportZoomSync';
import { useAppDispatch } from '@hooks/store';
import { setCanvasZoom } from '@store/slices/uiSlice';

const useCanvasZoomController = (): void => {
  const dispatch = useAppDispatch();
  const storeApi = useStoreApi();

  useEffect(() => {
    const sync = createViewportZoomSync({
      getZoom: () => storeApi.getState().transform[2],
      onZoomChange: (zoom) => dispatch(setCanvasZoom(zoom)),
    });

    const unsubscribe = storeApi.subscribe(sync.schedule);

    return () => {
      unsubscribe();
      sync.stop();
    };
  }, [storeApi, dispatch]);
};

export default useCanvasZoomController;
